<template lang="pug">
  SingleLayout(
    :item='true'
    :showcases='["tracks"]'
  )
    template(
      slot='item'
      v-if='track'
    )
      Track(
        type='full'
        :key='trackId'
        :index='0'
        :track='track'
        :tracklist='tracklist'
      )
    template(
      slot='showcase-tracks'
      v-if='tracksByArtist.length'
    )
      Showcase(
        :title='$l10n("TRACKS_SAME_ARTIST")'
        type='tracks'
        :key='trackId'
        :url='`/artists/${artistId}/tracks`'
        :items='tracksByArtist'
      )
</template>

<script>
import singlePage from "@/mixins/pages/single.mixin";
import PageLoader from "@/services/pageLoader";
import Showcase from "@/components/Showcase/Showcase";
import Track from "@/components/Track/Track";
import l10n from "@/services/l10n";
import errorHandler from "@/services/errorHandler";

import { mapGetters } from "vuex";
import { ITEMS_IN_SHOWCASE } from "@/constants";

const strategy = async function(route, ctx) {
  try {
    const id = PageLoader.getIdFromRoute(route);
    const { track = {} } = await PageLoader.getTrack({ id });

    ctx._track = track;
    ctx.trackId = id;

    route.meta.title = `${l10n("TRACK")} - ${track.title || l10n("NO_NAME")}`;
  } catch (error) {
    errorHandler.resolve(error);

    return;
  }

  try {
    const artistId = PageLoader.getFirstArtist(ctx._track);
    const { tracks: tracksByArtist = [] } = await PageLoader.getTracksByArtist({
      id: artistId
    });

    ctx.artistId = artistId;
    ctx.tracksByArtistIds = tracksByArtist
      .map(track => track.id)
      .filter(id => id !== ctx.trackId);
  } catch (error) {
    errorHandler.add(error);
  }
};

export default {
  name: "TrackPage",
  mixins: [singlePage(strategy)],
  data() {
    return {
      trackId: null,
      artistId: null,
      tracksByArtistIds: []
    };
  },
  computed: {
    ...mapGetters({
      tracks: "tracks/tracks"
    }),
    track() {
      return this.tracks[this.trackId];
    },
    tracksByArtist() {
      return this.tracksByArtistIds
        .slice(0, ITEMS_IN_SHOWCASE)
        .map(id => this.tracks[id]);
    },
    tracklist() {
      return {
        id: this.trackId,
        tracks: [this.trackId]
      };
    }
  },
  components: {
    Track,
    Showcase
  }
};
</script>
